import { useLocation } from "react-router-dom";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useHelpWidgetContext } from "../context/HelpWidgetContext";
import { BottomMenu } from "./BottomMenu";
import { HeaderBar } from "./HeaderBar";

interface HelpWidgetMobileContainerProps {
  children: React.ReactNode;
  onClose: () => void;
  pageName: string;
}

export const HelpWidgetMobileContainer = ({
  children,
  onClose,
  pageName,
}: HelpWidgetMobileContainerProps) => {
  const { isExpanded, isShowingLeaveWarning } = useHelpWidgetContext();
  const location = useLocation();
  const path = location.pathname;

  const isBottomMenuVisible =
    // eslint-disable-next-line sonarjs/prefer-regexp-exec -- Disabled for plugin version update. Fix when possible.
    !path.match(/^\/conversations\/\d+$/) &&
    !path.endsWith("/new_ticket") &&
    !path.startsWith("/message_confirmation/");

  const isHeaderBarVisible = !isShowingLeaveWarning;

  const isHomePage =
    path === "/" ||
    path.endsWith("/new_ticket") ||
    path.startsWith("/message_confirmation/");

  const isGradientVisible = path === "/";

  return (
    <div
      className={classNames("bg-primary flex flex-col rounded-2xl", {
        "h-screen-dynamic": !isExpanded,
      })}
      style={{
        transition: "height 300ms ease 0s",
      }}
    >
      {isGradientVisible && (
        <div className="relative left-0 top-0 flex w-96 opacity-10">
          <div className="absolute left-[27.06px] top-[474.84px] h-60 w-72 rounded-full bg-violet-600 blur-[106px]" />
          <div className="absolute left-[51.36px] top-[420px] h-44 w-56 rounded-full bg-rose-500 blur-[106px]" />
          <div className="absolute left-[156.85px] top-[494.50px] h-48 w-60 rounded-full bg-sky-200 blur-[106px]" />
          <div className="absolute left-0 top-[471.02px] h-32 w-28 rounded-full bg-sky-400 blur-[106px]" />
        </div>
      )}
      <div
        className={classNames(
          "relative h-full origin-bottom-right overflow-hidden",
          {
            "dark:border-primary border-b border-b-[#E4E7EB]":
              isBottomMenuVisible && !isHomePage,
          },
        )}
        style={{
          transition:
            "width 300ms ease 0s, transform 300ms cubic-bezier(0, 1.2, 1, 1) 0s",
        }}
      >
        <div className="relative z-10 flex size-full flex-col">
          {isHeaderBarVisible && (
            <HeaderBar pageName={pageName} onClose={onClose} />
          )}
          {children}
        </div>
      </div>
      {isBottomMenuVisible && (
        <div className="border-primary dark:bg-primary h-[66px] origin-bottom-right rounded-b-xl bg-white shadow-lg">
          <BottomMenu />
        </div>
      )}
    </div>
  );
};
